import { defineMessages, FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import Typography from 'components/Typography';
import heartSrc from 'components/ReferralWelcome/heart.svg';
import avifSrc from 'components/ReferralWelcome/landing-page-1-1400w.avif';
import webpSrc from 'components/ReferralWelcome/landing-page-1-1400w.webp';
import jpgSrc from 'components/ReferralWelcome/landing-page-1-1400w.jpg';
import logInviteFriendsBannerClicked from '@alltrails/analytics/events/logInviteFriendsBannerClicked';
import InviteFriendsBannerSource from '@alltrails/analytics/enums/InviteFriendsBannerSource';
import * as styles from './InviteYourFriendsBannerDesktop.module.scss';

const messages = defineMessages({
  heartAlt: {
    defaultMessage: 'heart icon'
  },
  heroAlt: {
    defaultMessage:
      "A close-up of two people's hands planting a redwood tree together. One is holding a tree in a black pot, while the other makes room for the tree to be planted in the ground among green redwood needles"
  },
  inviteYourFriends: {
    defaultMessage: 'Invite your friends'
  }
});

// https://app.zeplin.io/project/62193b4e4e72bf62a25f2093/screen/62193f2a58a9a15555d0ab11

export default function InviteYourFriendsBannerDesktop() {
  const intl = useIntl();

  return (
    <div className={styles.banner}>
      <div className={styles.heart}>
        <picture className={styles.picture}>
          <source srcSet={avifSrc} type="image/avif" />
          <source srcSet={webpSrc} type="image/webp" />
          <img alt={intl.formatMessage(messages.heroAlt)} src={jpgSrc} className={styles.img} />
        </picture>
        <img alt="" className={styles.icon} src={heartSrc} />
      </div>
      <div className={styles.content}>
        <Typography className={styles.invite} component="div" mb="16" variant="xltitle">
          <FormattedMessage defaultMessage="Invite your friends" />
        </Typography>
        <Typography className={styles.invite} component="div" mb="16" variant="body1">
          <FormattedMessage defaultMessage="Once they join, we’ll plant a tree for each of you" />
        </Typography>
        <Button
          text={intl.formatMessage(messages.inviteYourFriends)}
          linkInfo={{ href: '/refer' }}
          onClick={() => {
            logInviteFriendsBannerClicked({ source: InviteFriendsBannerSource.Homepage });
          }}
          testId="invite-your-friends-banner-cta"
          variant="inverse"
        />
      </div>
    </div>
  );
}
